export default __webpack_public_path__ + "static/media/CFS.130f7adc.svg";